import clx from 'classnames'
import Settings from '../settings'
import React from 'react'

export function CheckmarkWhiteIcon (props) {
  return (
    <div className={clx('mtt-cart-checkmark', props.className)}>
      <img
        src={Settings.getSetting(
          'icons/checkmark-white.svg',
          'cart-navigation'
        )}
      />
    </div>
  )
}